// src/GenAISection.js
import React from 'react';
import './GenAISection.css';

function GenAISection() {
  return (
    <div className="genai-section">
      <h2>🔬 GenAI in Agriculture</h2>
      <div className="genai-cards">
        <div className="genai-card">
          <img src="/images/genaifarm.png.jpeg" alt="GenAI Farm" />
          <h3>Smart Crop Planning</h3>
          <p>
            AI helps optimize crop rotation and resource allocation using historical data and predictive analytics.
          </p>
        </div>
        <div className="genai-card">
          <img src="/images/machinevision.png.jpeg" alt="Machine Vision" />
          <h3>Machine Vision</h3>
          <p>
            Using computer vision, AI identifies crop diseases early and improves quality control in sorting.
          </p>
        </div>
        <div className="genai-card">
          <img src="/images/smartirrigation.png.jpeg" alt="Smart Irrigation" />
          <h3>Smart Irrigation</h3>
          <p>
            AI-based weather prediction and soil sensing automate irrigation to reduce water usage.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GenAISection;
